import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './index.css';
import App from './App';
import AdminDashboard from './pages/AdminDashboard';
import AuthCallback from './pages/AuthCallback';
import ResetPassword from './pages/ResetPassword';
import { Toaster } from 'sonner';

// CRITICAL: Check for session_id in URL fragment BEFORE rendering normal routes
// This prevents race conditions with auth checks
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment (not query params) for session_id from Emergent Auth
  // This check must be synchronous (during render, not in useEffect)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/shopadmin" element={<AdminDashboard />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/*" element={<App />} />
    </Routes>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppRouter />
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  </React.StrictMode>
);
